import classNames from "classnames";
import path from "path-browserify";
import PropTypes from "prop-types";
import React from "react";
import url from "url";

const BLACKSCREEN = "bs";
const HTML5 = "html5";
const VIDEO = "video";
const VALID_IMAGE = "image";
const OTHER = "other";

class Asset extends React.Component {
  static get displayName() {
    return "Asset";
  }

  static get propTypes() {
    return {
      url: PropTypes.string,
      className: PropTypes.string,
      blackscreen: PropTypes.bool,
      preload: PropTypes.string,
      placeholder: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      blackscreen: false,
      preload: "auto",
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      type: OTHER,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this._checkUrl(this.props.url);
    };
  }

  componentDidMount() {
    this._checkUrl(this.props.url);
  }

  _checkUrl(link) {
    if (this.props.blackscreen) {
      return this.setState({ type: BLACKSCREEN });
    }

    link = link.toLowerCase();

    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      return this.setState({ type: OTHER });
    }

    const parsed = url.parse(link);
    const fname = path.basename(parsed.pathname);

    if (
      fname.endsWith(".mp4") ||
      fname.endsWith(".mpeg") ||
      fname.endsWith(".ogv") ||
      fname.endsWith(".webm")
    ) {
      return this.setState({ type: VIDEO });
    }

    if (fname.endsWith(".zip")) {
      return this.setState({ type: HTML5 });
    }

    if (
      fname.endsWith(".jpg") ||
      fname.endsWith(".jpeg") ||
      fname.endsWith(".gif") ||
      fname.endsWith(".png") ||
      fname.endsWith(".bmp")
    ) {
      return this.setState({ type: VALID_IMAGE });
    }

    return this.setState({ type: OTHER });
  }

  render() {
    if (this.state.type === BLACKSCREEN) {
      return this._renderBlackscreen();
    } else if (this.state.type === VIDEO) {
      return this._renderVideo();
    }
    return this._renderImage();
  }

  _renderBlackscreen() {
    let classes = classNames({ "asset-black-screen": true });
    if (this.props.className) {
      classes = classNames(classes, this.props.className);
    }

    return <div className={classes}></div>;
  }

  _renderImage() {
    let classes = classNames({ "asset-image": true });
    if (this.props.className) {
      classes = classNames(classes, this.props.className);
    }

    let imageUrl;
    if ([OTHER, HTML5].includes(this.state.type)) {
      imageUrl = this.props.placeholder;
      classes = classNames(classes, "asset-image-placeholder");
    } else {
      imageUrl = this.props.url;
    }

    return <img src={imageUrl} className={classes} />;
  }

  _renderVideo() {
    let classes = classNames({ "asset-video": true });
    if (this.props.className) {
      classes = classNames(classes, this.props.className);
    }

    const videoEl = (
      <video
        muted
        preload={this.props.preload}
        className={classes}
        controls={true}
      >
        <source src={this.props.url} />
      </video>
    );

    if (this.props.preload === "none") {
      return <div className="video-placeholder">{videoEl}</div>;
    }

    return videoEl;
  }
}

module.exports = Asset;
